import * as i0 from '@angular/core';
import { Directive, InjectionToken, Component, ChangeDetectionStrategy, Inject, Input, HostBinding, forwardRef, TemplateRef, ContentChildren, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

class FsRatingLabelDirective {
}
FsRatingLabelDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsRatingLabelDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
FsRatingLabelDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.16", type: FsRatingLabelDirective, selector: "[fsRatingLabel]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsRatingLabelDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fsRatingLabel]',
                }]
        }] });

const FS_RATING_CONFIG = new InjectionToken('fs-rating-config');
const FS_RATING_DEFAULT_CONFIG = new InjectionToken('fs-rating-default-config');

var StarTypes;
(function (StarTypes) {
    StarTypes["Filled"] = "filled";
    StarTypes["Half"] = "half";
    StarTypes["Empty"] = "empty";
})(StarTypes || (StarTypes = {}));
class FsRatingStarComponent {
    constructor(config) {
        this.selected = false;
        this.types = StarTypes;
        this.halfWidth = 100;
        this._type = StarTypes.Empty;
        this.selectedColor = config.selectedColor;
        this.unselectedColor = config.unselectedColor;
    }
    set setUnselectedColor(value) {
        this.unselectedColor = value;
    }
    set setselectedColor(value) {
        this.selectedColor = value;
    }
    set value(value) {
        this._value = value;
        this._updateType();
    }
    set type(value) {
        this._type = value;
        this.selected = this._type === StarTypes.Filled || this._type === StarTypes.Half;
    }
    get type() {
        return this._type;
    }
    get value() {
        return this._value;
    }
    _updateType() {
        this.type = StarTypes.Empty;
        const value = this.value - (this.index - 1);
        if (value > 0) {
            this.type = value >= 1 ? StarTypes.Filled : StarTypes.Half;
            if (this.type === StarTypes.Half) {
                this.halfWidth = 50;
            }
        }
    }
}
FsRatingStarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsRatingStarComponent, deps: [{ token: FS_RATING_DEFAULT_CONFIG }], target: i0.ɵɵFactoryTarget.Component });
FsRatingStarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: FsRatingStarComponent, selector: "fs-rating-star", inputs: { index: "index", setUnselectedColor: ["unselectedColor", "setUnselectedColor"], setselectedColor: ["selectedColor", "setselectedColor"], labelTemplate: "labelTemplate", value: "value" }, host: { properties: { "class.with-labels": "this.labelTemplate", "class.selected": "this.selected" } }, ngImport: i0, template: "<ng-container *ngIf=\"!!labelTemplate; else withoutLabels\">\n  <ng-template [ngTemplateOutlet]=\"star\"></ng-template>\n  <span class=\"label\">\n    <ng-template [ngTemplateOutlet]=\"labelTemplate\"></ng-template>\n  </span>\n</ng-container>\n\n<ng-template #withoutLabels>\n  <ng-template [ngTemplateOutlet]=\"star\"></ng-template>\n</ng-template>\n\n<ng-template #star>\n  <div class=\"star\" [ngClass]=\"type\">\n    <ng-container [ngSwitch]=\"type\">\n      <ng-container *ngSwitchCase=\"types.Filled\">\n        <i class=\"material-icons selected\" [style.color]=\"selectedColor\">star</i>\n      </ng-container>\n      <ng-container *ngSwitchCase=\"types.Half\">\n        <i class=\"material-icons selected\" [style.color]=\"selectedColor\" [style.width]=\"halfWidth + '%'\">star</i>\n        <i class=\"material-icons unselected\" [style.color]=\"unselectedColor\">star</i>\n      </ng-container>\n      <ng-container *ngSwitchCase=\"types.Empty\">\n        <i class=\"material-icons unselected\" [style.color]=\"unselectedColor\">star</i>\n      </ng-container>\n    </ng-container>\n  </div>\n</ng-template>\n", styles: [":host{display:inline-flex}:host.with-labels{flex-direction:column;align-items:center;width:50px}:host.with-labels:last-child{padding-right:0}:host .star{text-align:center;position:relative;display:flex}:host .label{font-size:smaller;margin-top:9px}:host .star.half .selected{position:relative;z-index:1;overflow:hidden}:host .star.half .unselected{position:absolute;left:0}\n"], directives: [{ type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { type: i1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsRatingStarComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fs-rating-star',
                    templateUrl: 'star.component.html',
                    styleUrls: ['star.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FS_RATING_DEFAULT_CONFIG]
                }] }]; }, propDecorators: { index: [{
                type: Input
            }], setUnselectedColor: [{
                type: Input,
                args: ['unselectedColor']
            }], setselectedColor: [{
                type: Input,
                args: ['selectedColor']
            }], labelTemplate: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.with-labels']
            }], value: [{
                type: Input
            }], selected: [{
                type: HostBinding,
                args: ['class.selected']
            }] } });

class FsRatingComponent {
    constructor(_cd, config) {
        this._cd = _cd;
        this.showValue = false;
        this.selectable = false;
        this.onChange = () => { };
        this.onTouch = () => { };
        this.visibleValue = 0;
        this.stars = [];
        this.labelTemplates = [];
        this._maxRange = 5;
        this.selectedColor = config.selectedColor;
        this.unselectedColor = config.unselectedColor;
    }
    set maxRange(value) {
        this._maxRange = value;
        this.initStars();
    }
    ;
    set setUnselectedColor(value) {
        this.unselectedColor = value;
    }
    set setselectedColor(value) {
        this.selectedColor = value;
    }
    set labels(values) {
        this.labelTemplates = values.toArray();
        this._cd.detectChanges();
    }
    set value(value) {
        if (value !== this._value) {
            this._value = value;
            this.visibleValue = this._value;
            this.initStars();
            this._cd.detectChanges();
            this.onChange(value);
            this.onTouch(value);
        }
    }
    get value() {
        return this._value;
    }
    ngOnInit() {
        this.initStars();
    }
    writeValue(value) {
        const val = +value;
        if (value !== null && typeof (val) === 'number' && val !== this.value) {
            this._value = val;
            this.visibleValue = this._value;
            this._cd.detectChanges();
        }
    }
    /**
     * Init number of not filled stars
     */
    initStars() {
        this.stars = [];
        for (let i = 1; i <= this._maxRange; i++) {
            this.stars.push(i);
        }
        this._cd.detectChanges();
    }
    /**
     * Select star and save rating
     * @param index
     */
    selectStar(index) {
        if (this.selectable) {
            if (this.value && this.value === index) {
                this.value = 0;
            }
            else {
                this.value = index;
            }
        }
    }
    registerOnChange(fn) { this.onChange = fn; }
    registerOnTouched(fn) { this.onTouch = fn; }
}
FsRatingComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsRatingComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: FS_RATING_DEFAULT_CONFIG }], target: i0.ɵɵFactoryTarget.Component });
FsRatingComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: FsRatingComponent, selector: "fs-rating", inputs: { maxRange: "maxRange", showValue: "showValue", setUnselectedColor: ["unselectedColor", "setUnselectedColor"], setselectedColor: ["selectedColor", "setselectedColor"], selectable: "selectable" }, host: { properties: { "class.selectable": "this.selectable" } }, providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FsRatingComponent),
            multi: true
        }], queries: [{ propertyName: "labels", predicate: FsRatingLabelDirective, read: TemplateRef }], ngImport: i0, template: "<ng-container *ngFor=\"let star of stars;\">\n  <fs-rating-star\n    [value]=\"value\"\n    [unselectedColor]=\"unselectedColor\"\n    [selectedColor]=\"selectedColor\"\n    [index]=\"star\"\n    [labelTemplate]=\"labelTemplates[star - 1]\"\n    (click)=\"selectStar(star)\">\n  </fs-rating-star>\n</ng-container>\n\n<span class=\"rating-value\" *ngIf=\"showValue\">{{visibleValue}}</span>\n", styles: [":host{display:flex;align-items:center;cursor:default;-webkit-tap-highlight-color:transparent;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}:host.selectable{cursor:pointer}:host .rating-value{min-width:1em;margin-left:6px}\n"], components: [{ type: FsRatingStarComponent, selector: "fs-rating-star", inputs: ["index", "unselectedColor", "selectedColor", "labelTemplate", "value"] }], directives: [{ type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsRatingComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fs-rating',
                    templateUrl: 'rating.component.html',
                    styleUrls: ['rating.component.scss'],
                    providers: [{
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => FsRatingComponent),
                            multi: true
                        }],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FS_RATING_DEFAULT_CONFIG]
                }] }]; }, propDecorators: { maxRange: [{
                type: Input
            }], showValue: [{
                type: Input
            }], setUnselectedColor: [{
                type: Input,
                args: ['unselectedColor']
            }], setselectedColor: [{
                type: Input,
                args: ['selectedColor']
            }], selectable: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.selectable']
            }], labels: [{
                type: ContentChildren,
                args: [FsRatingLabelDirective, { read: TemplateRef }]
            }] } });

class FsRatingModule {
    static forRoot(config = {}) {
        return {
            ngModule: FsRatingModule,
            providers: [
                {
                    provide: FS_RATING_CONFIG,
                    useValue: config
                },
                {
                    provide: FS_RATING_DEFAULT_CONFIG,
                    useFactory: FsRatingConfigFactory,
                    deps: [FS_RATING_CONFIG],
                }
            ]
        };
    }
}
FsRatingModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsRatingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FsRatingModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsRatingModule, declarations: [FsRatingComponent,
        FsRatingStarComponent,
        FsRatingLabelDirective], imports: [CommonModule], exports: [FsRatingComponent,
        FsRatingLabelDirective] });
FsRatingModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsRatingModule, providers: [], imports: [[
            CommonModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsRatingModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                    ],
                    exports: [
                        FsRatingComponent,
                        FsRatingLabelDirective,
                    ],
                    entryComponents: [],
                    declarations: [
                        FsRatingComponent,
                        FsRatingStarComponent,
                        FsRatingLabelDirective,
                    ],
                    providers: [],
                }]
        }] });
function FsRatingConfigFactory(config) {
    return Object.assign({}, {
        unselectedColor: '#E7E7E7',
        selectedColor: '#F8C100'
    }, config || {});
}

/*
 * Public API Surface of fs-menu
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FsRatingComponent, FsRatingLabelDirective, FsRatingModule };
